import { Fragment, useState } from "react";
import React from "react";
import { Dialog, Menu, Transition, Listbox } from "@headlessui/react";
import { Link, Navigate } from "react-router-dom";
import mainLogo from "../mglogo.png";
import {
  BellIcon,
  CalendarIcon,
  ChartBarIcon,
  FolderIcon,
  HomeIcon,
  InboxIcon,
  ShoppingBagIcon,
  MenuAlt2Icon,
  UsersIcon,
  ArchiveIcon,
  PlusSmIcon as PlusSmIconSolid,
  XIcon,
} from "@heroicons/react/outline";
import {
  CheckCircleIcon,
  SearchIcon,
  CheckIcon,
  SelectorIcon,
  CogIcon,
} from "@heroicons/react/solid";
import axios from "axios";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

class Configunitmodal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showmsg: false,
      success: false,
      redirect: false,
      unique_quantity_codesList: [],
      configureunit: [{ unit_name: "", unique_quantity_code_id: 0 }],
      error_list: [],
      loader: "",
    };
    //this.handleInput = this.handleInput.bind(this);
    this.handleInputName = this.handleInputName.bind(this);
  }
  close = async (e) => {
    this.setState({ sidebarOpen: false });
  };
  open = async (e) => {
    console.log("open")
    this.setState({ sidebarOpen: true });
  };

  componentDidMount() {
    const token = localStorage.getItem("token");

    const res1 = axios
      .get("public/api/item/unique-quantity-codes", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res1) => {
        this.setState({
          unique_quantity_codesList: res1.data.unique_quantity_codes,
        });
      });

    const res2 = axios
      .get("public/api/item/units", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res2) => {
        this.state.configureunit = res2.data.units;
        this.setState({
          configureunit: this.state.configureunit,
        });
      });
  }

  handleInput = (e, index) => {
    this.state.configureunit[index].unique_quantity_code_id = e.target.value;
    this.setState({ configureunit: this.state.configureunit });
  };

  handleInputName = (e, index) => {
    this.state.configureunit[index].unit_name = e.target.value;
    this.setState({ configureunit: this.state.configureunit });
  };

  addconfig = (e) => {
    this.setState({
      configureunit: this.state.configureunit.concat([
        {
          unit_name: "",
          unique_quantity_code_id: 0,
        },
      ]),
    });
  };

  handleInputwarehouseF = (e) => {
    this.props.handleResultofModal(e);
  };

  saveItem = async (e) => {
    e.preventDefault();

    var token = localStorage.getItem("token");
    const headers = {
      authorization: `Bearer ${token}`,
      Accept: "application/json",
    };

    const res = await axios.post(
      "public/api/item/configure-units",
      this.state,
      {
        headers,
      }
    );

    if (res.data.success) {
      this.setState({ showmsg: true });
      this.handleInputwarehouseF(res.data.success);
      setTimeout(
        function () {
          //Start the timer
          this.setState({ redirect: true }); //After 1 second, set render to true
        }.bind(this),
        1000
      );
    } else {
      this.setState({ error_list: res.data.data });
      //this.setState({ show: true })
    }
  };

  //Logout function

  logout = async (e) => {
    e.preventDefault();
    var token = localStorage.getItem("token");

    const res = await axios.get("public/api/logout", {
      headers: {
        authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    //console.log(res);

    if (res.data.success) {
      localStorage.removeItem("token");

      this.setState({ logoutRedirect: true }); //After 1 second, set render to true
    }
  };

  //Logout function

  render() {
    let token = localStorage.getItem("token");

    if (token == null) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.logoutRedirect) {
      return <Navigate to={"/Login"} />;
    }

    return (
      <>
        {/*
        This example requires updating your template:

        ```
        <html class="h-full bg-gray-100">
        <body class="h-full">
        ```
      */}

        <main className="flex-1">
          <div className="py-6">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
              <h1 className="text-2xl font-semibold text-gray-900">
                Configure Unit
              </h1>
            </div>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
              {/* Replace with your content */}

              <div className="hidden sm:block" aria-hidden="true">
                <div className="py-5">
                  <div className="border-t border-gray-200" />
                </div>
              </div>
              <div className={`mt-10 sm:mt-0 ${this.state.loader}`}>
                <div className="md:grid md:gap-6">
                  <div className="mt-5 md:mt-0 md:col-span-2">
                    <form onSubmit={this.saveItem}>
                      <div className="shadow overflow-hidden sm:rounded-md">
                        <div className="px-4 py-5 bg-white sm:p-6">
                          {this.state.configureunit.map((item, index) => (
                            <div className="grid grid-cols-6 gap-6">
                              <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                <label
                                  htmlFor="unit_name"
                                  className="block text-sm font-medium text-gray-700"
                                >
                                  Name
                                </label>
                                <input
                                  type="text"
                                  name="unit_name"
                                  id={index}
                                  cui={index}
                                  value={item.unit_name}
                                  onChange={(evt) =>
                                    this.handleInputName(evt, index)
                                  }
                                  autoComplete="unit_name"
                                  className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                />
                                <p
                                  className="mt-2 text-sm text-red-600"
                                  id="unit_name-error"
                                >
                                  {this.state.error_list.unit_name}
                                </p>
                              </div>

                              <div className="col-span-6 sm:col-span-3 lg:col-span-3">
                                <label
                                  htmlFor="unique_quantity_codes"
                                  className="block text-sm font-medium text-gray-700"
                                >
                                  Unit*
                                </label>
                                <select
                                  id="unique_quantity_code_id"
                                  name="unique_quantity_code_id"
                                  value={item.unique_quantity_code_id}
                                  onChange={(evt) =>
                                    this.handleInput(evt, index)
                                  }
                                  autoComplete="unique_quantity_code_id"
                                  className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                >
                                  <option value="">------</option>
                                  {this.state.unique_quantity_codesList.map(
                                    (number) => (
                                      <option value={number.id}>
                                        {number.name}
                                      </option>
                                    )
                                  )}
                                </select>
                                <p
                                  className="mt-2 text-sm text-red-600"
                                  id="unique_quantity_code_id-error"
                                >
                                  {
                                    this.state.error_list
                                      .unique_quantity_code_id
                                  }
                                </p>
                              </div>
                            </div>
                          ))}
                          <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                            <div className="grid grid-cols-6 gap-6">
                              <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                <button
                                  type="button"
                                  className="inline-flex items-center p-1 border border-transparent rounded-full shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                  onClick={this.addconfig}
                                >
                                  <PlusSmIconSolid
                                    className="h-5 w-5"
                                    aria-hidden="true"
                                  />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                          <button
                            type="submit"
                            className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              {/* /End replace */}
            </div>
          </div>
        </main>

        <div
          aria-live="assertive"
          className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
        >
          <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
            {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
            <Transition
              show={this.state.showmsg}
              //show={true}
              as={Fragment}
              enter="transform ease-out duration-300 transition"
              enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
              enterTo="translate-y-0 opacity-100 sm:translate-x-0"
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 mt-10">
                <div className="p-4">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <CheckCircleIcon
                        className="h-6 w-6 text-green-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="ml-3 w-0 flex-1 pt-0.5">
                      <p className="text-sm font-medium text-gray-900">
                        Successfully Saved
                      </p>
                      <p className="mt-1 text-sm text-gray-500"></p>
                    </div>
                    <div className="ml-4 flex-shrink-0 flex">
                      <button
                        className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        onClick={() => {
                          this.setState({ showmsg: false });
                        }}
                      >
                        <span className="sr-only">Close</span>
                        <XIcon className="h-5 w-5" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        </div>
      </>
    );
  }
}

export default Configunitmodal;
